<template>
    <!-- Add Task Modal -->
    <div class="modal fade" id="orderDatesModal" ref="orderDatesModal" tabindex="-1" aria-labelledby="taskModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 900px;">
            <div class="modal-content border-0">
                <div class="modal-header p-3 bg-soft-info">
                    <h5 class="modal-title" id="taskModalLabel">
                        {{task ? task.title : ''}}
                    </h5>
                    <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">&times;</button>
                </div>
                <div class="modal-body" v-if="form">
                    <div class="alert alert-success" role="alert" v-if="successMessage">
                        {{ successMessage }}
                    </div>

                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="javascript:void(0);" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <ValidationObserver v-slot="{ handleSubmit }" ref="formValidation" name="addTask">
                        <form @submit.prevent="handleSubmit(submitHandler)" enctype="multipart/form-data">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">
                                            <template v-if="dateType == 'etd'">ETA</template>
                                            <template v-else>Factory ready date</template>
                                        </label>
                                        <ValidationProvider name="Factory ready date" rules="required" v-slot="{ errors }">
                                            <date-picker v-model="form.eta" format="MM/DD/YYYY" valueType="format"></date-picker>
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-md-6" v-if="dateType != 'etd'">
                                    <div class="mt-3">
                                        <label class="form-label">Follow up date</label>
                                        <ValidationProvider name="Follow up date" rules="required" v-slot="{ errors }">
                                            <date-picker v-model="form.follow_up" format="MM/DD/YYYY" valueType="format"></date-picker>
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-md-6" v-if="dateType == 'etd'">
                                    <div class="mt-3">
                                        <label class="form-label">ETD</label>
                                        <ValidationProvider name="Follow up date" rules="required" v-slot="{ errors }">
                                            <date-picker v-model="form.etd" format="MM/DD/YYYY" valueType="format"></date-picker>
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>
                                </div>

                            </div>
                            <div class="row" v-if="dateType != 'etd'">
                                <div class="col-md-12" v-if="form.eta != null">
                                    <div class="mt-3">
                                        <label class="form-label">Reason</label>
                                        <textarea class="form-control"
                                                  v-model="form.reason" placeholder="" rows="2"
                                                  style="height:66px;overflow-y:hidden;"></textarea>
                                    </div>
                                </div>

                            </div>
                            <div class="mt-3 text-end">
                                <button type="submit" :disabled="loading" class="btn btn-primary fw-semibold fs-14 px-4">
                                    <template v-if="dateType == 'confirm'">Confirm</template>
                                    <template v-else>Save</template>
                                </button>
                            </div>
                        </form>
                    </ValidationObserver>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {ValidationProvider, ValidationObserver, extend, configure} from 'vee-validate';
import axios from "axios";
import DatePicker from "vue2-datepicker";
import {mapActions, mapGetters,} from "vuex";

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
        // ...
    }
});

extend('positive', value => {
    if (value >= 0) {
        return true;
    }

    return 'This field must be a positive number';
});

export default {
    name: "OrderDatesModal",
    props:['order', 'task', 'loading', 'bus', 'orderType', 'dateType'],
    components:{
        ValidationObserver, ValidationProvider,
        DatePicker
    },
    created() {
    },
    mounted() {
        let self = this;
        if(this.bus) {
            this.bus.$on('triggerCompleteTask', (id) => {
                //self.completeTask(id);
            });
        }

        $("#orderDatesModal").on('show.bs.modal', () => {
            if(self.dateType){
                self.form.date_type = _.cloneDeep(self.dateType);
            }
            if(self.task){
                self.form.task_id = _.cloneDeep(self.task.id);
            }
            if(self.order) {
                self.form.order_id = _.cloneDeep(self.order.id);
                self.form.eta = _.cloneDeep(self.order.eta);
                self.form.follow_up = _.cloneDeep(self.order.follow_up);
            } else if(self.task && self.task.taskable) {
                self.form.order_id = _.cloneDeep(self.task.taskable.id);
                self.form.eta = _.cloneDeep(self.task.taskable.eta);
                self.form.follow_up = _.cloneDeep(self.task.taskable.follow_up);
            }
        });

        $('#orderDatesModal').on('hidden.bs.modal', function () {
            self.form = {
                order_id: null,
                order_type: 'po',
                eta: null,
                etd: null,
                follow_up: null,
                reason: null,
                task_id: null,
                date_type: 'eta',
            };
            self.$refs.formValidation.reset();
        });
    },
    data(){
        return {
            form: {
                order_id: null,
                order_type: 'po',
                eta: null,
                etd: null,
                follow_up: null,
                reason: null,
                task_id: null,
                date_type: 'eta'
            },
        };
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        submitHandler() {
            this.$refs.formValidation.validate().then(success => {
                if (!success) {
                    return;
                }

                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.post(window.route('po.changeDates', {id: this.form.order_id}), this.form,{

                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({data}) => {
                        if (data.errors && Object.keys(data.errors).length) {
                            self.setCommonErrors(data.errors);
                        } else if (data.errorMessage) {
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.setSuccessMessage(data.data);
                            setTimeout(() => {
                                self.setSuccessMessage(null);
                            }, 5000);
                            self.$emit('orderDateUpdated', data);
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setLoading(false);

                    });

            });
        },
    },
    computed: {
        ...mapGetters([
            'commonErrors',
            'errorMessage',
            'successMessage'
        ])
    },
    watch: {
        'form.assign_admins': {
            handler: function (after, before) {
                this.form.assign_ids = [];
                if(after) {
                    after.forEach((x) => {
                        this.form.assign_ids.push(x.id);
                    })
                }
            },
            deep: true
        },
        'form.order_type': {
            handler: function (after, before) {
                this.orders = [];
                this.form.order_id = null;
                this.form.order = null;
            },
            deep: true
        },
    }
}
</script>

<style scoped>

</style>
